import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Enum } from '../models/base';

@Injectable({
  providedIn: 'root'
})
export class EnumService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any
  ) {}

  public get(name: string): Observable<Enum[]> {
    let headers = new HttpHeaders();
    //We want to cache these requests
    headers = headers.set('X-Cache-Lifetime', '3600');

    return this.http.get<Enum[]>(`${this.env.apiUrlRoot}/enums/Aps/${name}`, { headers });
  }

  public getRelay(name: string): Observable<Enum[]> {
    let headers = new HttpHeaders();
    //We want to cache these requests
    headers = headers.set('X-Cache-Lifetime', '3600');

    return this.http.get<Enum[]>(`${this.env.apiUrlRoot}/enums/Relay/${name}`, { headers });
  }
}
